/**
 * lockCopy.ts — the two sentences a frozen advance says, in one place.
 *
 * THE LOCK IS ONE RULE AND IT IS DRAWN ON TWO CANVASES [F7]. `agreement_documents.frozen_at` is set
 * at the FIRST signature, and from that moment the figures the Schedule printed cannot move
 * underneath it — so the disbursement area and the repayment area both render read-only behind the
 * same line. Two copies of a sentence naming a control is how the two areas end up pointing an
 * admin at two different doors.
 *
 * IT NAMES THE REAL CONTROL. "Locked" on its own is a dead end; the correction exists and it is
 * void-and-reissue, in the agreement row's own overflow menu, which withdraws the signed instrument
 * and raises a replacement over the corrected figures.
 */

export const FROZEN_LOCK_TITLE = 'Locked — the Operational Expense Advance is signed';

export const FROZEN_LOCK_BODY =
    'A party has signed the Schedule, so the figures it printed are frozen. To change them, use ' +
    '“Void & reissue” in the agreement row’s overflow menu on the Agreement area: that withdraws ' +
    'the signed instrument and raises a replacement over the corrected figures.';
